import { authenticatedAxios } from "@api/timereports";
import { getReceiptUri } from "./receipt-uri";
import { receiptFileName, ReceiptSubject } from "./receipt-file-name";

/**
 * Saves a receipt under a name that opens.
 *
 * The blob is fetched rather than linked to because the response is the only place the file's
 * real type is stated: an `<a download>` carries a name decided before the request, and the
 * name the service serves is the stored one, which is a guid.
 */
export const downloadReceipt = async (previewUri: string, subject: ReceiptSubject) => {
  const response = await authenticatedAxios.get(getReceiptUri(previewUri), {
    responseType: "blob"
  });

  const url = URL.createObjectURL(response.data);
  const link = document.createElement("a");

  link.href = url;
  link.download = receiptFileName(response.headers["content-type"], subject);

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
